import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../Services/generalservice.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-recuiter-register',
  templateUrl: './recuiter-register.component.html',
  styleUrls: ['./recuiter-register.component.scss']
})
export class RecuiterRegisterComponent {
    HomeUrl: any;
    CompanyName: any;
    RecruiterName: any;
    Mobile: any;
    Email: any;
    Password: any;
    recuiter: any;
    arr: any;
    logindetails: any;
    mobleexist: any;
    // Track password visibility
    showPassword: boolean = false;
    mobileError: string | null = null;
    checkNo: any;
    passwordError: string | null = null;
    emailError: string | null = null;
 

    constructor(private router: Router, public generalservice: GeneralService, public http: HttpClient) {
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
        });
    }

    ngOnInit(): void { }

    // Validate mobile number - exactly 10 digits, starting with 6, 7, 8, or 9
    validateMobile(): boolean {
        const mobilePattern = /^[6-9][0-9]{9}$/; // 6, 7, 8, or 9 at the start, and 10 digits total
        if (this.Mobile && !mobilePattern.test(this.Mobile)) {
            this.mobileError = 'Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9';
            return false;
        } else {
            this.mobileError = null;
            return true;
        }
    }

    // Validate email format
    validateEmail(): boolean {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email pattern
        if (this.Email && !emailPattern.test(this.Email)) {
            this.emailError = 'Please enter a valid email address';
            return false;
        } else {
            this.emailError = null;
            return true;
        }
    }

    // Validate password (basic length check)
    validatePassword(): boolean {
        if (this.Password.length < 6) {
            this.passwordError = 'Password must be at least 6 characters long';
            return false;
        } else {
            this.passwordError = null;
            return true;
        }
    }

    // Check if the entire form is valid before submission
    isFormValid(): boolean {
        return this.validateMobile() && this.validateEmail() && this.validatePassword();
    }

    // Registration process
    registration() {
        debugger
        // Validate form before proceeding
        if (!this.isFormValid()) {
            this.generalservice.ShowAlert("ERROR", 'Please fill all fields correctly', 'error');
            return;
        }

        // Check if mobile number already exists
        if (this.mobleexist === 'Mobile Exists') {
            this.generalservice.ShowAlert("ERROR", 'Your Mobile Number Already Exists, Please Login', 'error');
            this.router.navigate(['/Login']);
            return;
        }

        // Clear any existing localStorage items
        localStorage.clear();

        // Prepare registration data
        this.arr = [{
            //CompanyName: this.CompanyName,
            RecruiterName: this.RecruiterName,
            MobileNo: this.Mobile,
            Email: this.Email,
            Password: this.Password
        }];

        const uploadfile = new FormData();
        uploadfile.append("Param", JSON.stringify(this.arr));
        uploadfile.append("Flag", "1");

        // Make registration API call
        const url = "api/Njobs/RecruiterRegister_Crud";
        this.generalservice.PostData(url, uploadfile).then(data => {
            debugger
            if (data === 'SUCCESS') {
               
              
                this.generalservice.ShowAlert("SUCCESS", 'Your Registration Completed Successfully', 'success');
                this.login(); // Call login after registration
            } else {
                // Show error if registration fails
                this.generalservice.ShowAlert("ERROR", 'Something went wrong', 'error');
            }
        });
    }

    // Login process after registration
    login() {
        debugger
        const uploadfile = new FormData();
        uploadfile.append("MobileNo", this.Mobile);
        uploadfile.append("Password", this.Password);

        const url = "api/Njobs/RecruiterLogin";
        this.generalservice.PostData(url, uploadfile).then(data => {
            if (data != null) { // Ensure login data is available
              
                localStorage.setItem("LoginDetails", JSON.stringify(data));
                this.router.navigate(['/company-account']).then(() => {
                    window.location.reload();
                });
            } else {
                // Handle login error if login data is not returned
                this.generalservice.ShowAlert("ERROR", 'Login failed. Please try again.', 'error');
            }
        });
    }


    // Toggle password visibility
    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    CheckMobile() {
        var uploadfile = new FormData();
        uploadfile.append("Param1", '3');
        uploadfile.append("Param2", this.Mobile);
        var url = "api/Njobs/Check_Mobile_Email_AlredyExists";
        this.generalservice.PostData(url, uploadfile).then(data => {
            if (data == 'Mobile Exists') {
                this.mobleexist = data;
                this.checkNo = 'Mobile Number Already Exists'
            } else {
                this.checkNo == 11
            }
        })

    }

}



